import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center gap-2" }
const _hoisted_3 = { class: "text-muted small" }

import { computed, shallowRef, watch } from 'vue';
import KpiCard from './KpiCard.vue';
import LowBudgetTicker from './LowBudgetTicker.vue';
import PageProgress from './PageProgress.vue';
import { LOW_BUDGET_THRESHOLD } from '../utils/budget.js';

// Two columns of three; the tile only cycles through the most critical students
const PAGE_SIZE = 6;
const MAX_PAGES = 5;
const PAGE_DURATION_MS = 5000;


export default {
  __name: 'LowBudgetKpiCard',
  props: {
  /** Low-budget students, most critical first. */
  students: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const hint = `Anzahl aktiver Studenten (mit Budget) mit weniger als ${LOW_BUDGET_THRESHOLD} verfügbaren Punkten`;

const title = computed(() => `Niedriges Budget (${props.students.length})`);

const page = shallowRef(0);
const isHovered = shallowRef(false);
const hasFocus = shallowRef(false);

const pages = computed(() => {
  const visible = props.students.slice(0, PAGE_SIZE * MAX_PAGES);
  const result = [];
  for (let i = 0; i < visible.length; i += PAGE_SIZE) {
    result.push(visible.slice(i, i + PAGE_SIZE));
  }
  return result;
});

const currentStudents = computed(() => pages.value[page.value] ?? []);

// Students beyond the cycled pages; the heading still shows the full count
const hiddenCount = computed(() => Math.max(props.students.length - PAGE_SIZE * MAX_PAGES, 0));
const hiddenHint = `Die Kachel zeigt die ${PAGE_SIZE * MAX_PAGES} Studierenden mit dem geringsten Budget. `
  + 'Alle weiteren in der Studententabelle, Spalte „Verfügbar“.';

// A refresh can shrink the list below the current page
watch(
  () => pages.value.length,
  (count) => {
    if (page.value >= count) {
      page.value = 0;
    }
  },
);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Pausing covers the whole tile, including the progress segments in the footer "),
    _createVNode(KpiCard, {
      title: title.value,
      icon: "fas fa-exclamation-triangle",
      "icon-color-class": "text-warning",
      compact: "",
      onMouseenter: _cache[1] || (_cache[1] = $event => (isHovered.value = true)),
      onMouseleave: _cache[2] || (_cache[2] = $event => (isHovered.value = false)),
      onFocusin: _cache[3] || (_cache[3] = $event => (hasFocus.value = true)),
      onFocusout: _cache[4] || (_cache[4] = $event => (hasFocus.value = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(" < " + _toDisplayString(_unref(LOW_BUDGET_THRESHOLD)) + " Punkte verfügbar ", 1 /* TEXT */),
            _createElementVNode("i", {
              class: "fas fa-info-circle ms-1",
              title: hint,
              "data-bs-toggle": "tooltip"
            }),
            (hiddenCount.value > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "ms-2",
                  title: hiddenHint
                }, "+" + _toDisplayString(hiddenCount.value) + " weitere", 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          (pages.value.length > 1)
            ? (_openBlock(), _createBlock(PageProgress, {
                key: 0,
                modelValue: page.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((page).value = $event)),
                count: pages.value.length,
                "duration-ms": PAGE_DURATION_MS,
                paused: isHovered.value || hasFocus.value
              }, null, 8 /* PROPS */, ["modelValue", "count", "paused"]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      default: _withCtx(() => [
        (pages.value.length > 0)
          ? (_openBlock(), _createBlock(LowBudgetTicker, {
              key: 0,
              students: currentStudents.value,
              "page-key": page.value
            }, null, 8 /* PROPS */, ["students", "page-key"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, " Keine Studierenden betroffen "))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

}